module.exports = __webpack_public_path__ + "yadokari-moshi-2.png?c22472304b614a577bbf8338660549c3";


//////////////////
// WEBPACK FOOTER
// ./static/img/yadokari-moshi-2.png
// module id = 461
// module chunks = 0